import React from "react";
import { Row, Col, Alerta, TipoAlerta } from "@intechprev/componentes-web";
import { FichaFinanceiraService, LogService } from "../../../services";

import { PlanoVinculadoEntidade, WebCapitalSeguradoEntidade } from "../../../entidades";
import { MasterPage, NumFuncionalidade } from "../../MasterPage";
import { CapitalSegurado } from "./../CapitalSegurado";
import { Saldo } from "./Saldo";
import { UltimasContribuicoes } from "./UltimasContribuicoes";
import { Header } from "./Header";
import { reCAPTCHA } from "../../../helpers";

interface Props {
  plano: PlanoVinculadoEntidade;
  renderSelecionarPlano: any;
}

interface State {
  salario: Array<any>;
  ultimaContribuicao: any;
  valores: {
    funeral: number;
    invalidez: number;
  };
  CapitalSegurado: WebCapitalSeguradoEntidade;
}

export class Ativo extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("home_ativo");

  public page = React.createRef<MasterPage>();

  constructor(props: Props) {
    super(props);

    this.state = {
      salario: [],
      ultimaContribuicao: null,
      valores: {
        funeral: 0,
        invalidez: 0,
      },
      CapitalSegurado: null,
    };
  }

  componentDidMount = async () => {
    try {
      await this.page.current.alternarLoading();
      await LogService.CriarLog(NumFuncionalidade.HOME_ATIVOS_E_AUTOPATROCINADOS);
      await this.carregarPlano();

      const CapitalSegurado = await FichaFinanceiraService.BuscarCapitalSegurado();

      if (CapitalSegurado.length > 0) {
        this.setState({
          CapitalSegurado: CapitalSegurado[0],
        });
      }

      await this.page.current.alternarLoading();
    } catch (err) {
      console.log(err);
    }
  };

  carregarPlano = async () => {
    try {
      var ultimaContribuicao = await FichaFinanceiraService.BuscarUltimaExibicaoPorPlano(this.props.plano.CD_PLANO);

      await this.setState({
        ultimaContribuicao,
        salario: ultimaContribuicao.salario,
        valores: {
          funeral: ultimaContribuicao.valorFuneral[0] ? ultimaContribuicao.valorFuneral[0].LIMITE_SUP_FAIXA : 0,
          invalidez: ultimaContribuicao.valorInvalidez[0] ? ultimaContribuicao.valorInvalidez[0].LIMITE_SUP_FAIXA : 0,
        },
      });
    } catch (e) {
      const err: any = e;
      alert(err.response ? err.response.data : err);
    }
  };

  renderSaldoDeCotasCaption = (data: any, valor: any) => {
    valor = String(valor).replace(".", ",");
    return <caption>{`Valor da cota em ${data}: ${valor}`}</caption>;
  };

  participanteAutopatrocinio = () => {
    return this.props.plano.CD_SIT_PLANO === "30";
  };

  handleEnviar = async () => {
    console.log("Enviado");
  };

  renderComBeneficio = () => {
    return (
      <>
        {this.props.renderSelecionarPlano()}

        <Header
          plano={this.props.plano}
          valorSalario={this.state.salario.length > 0 ? this.state.salario[0].SRC : 0}
          dataSalario={this.state.salario.length > 0 ? `em ${this.state.salario[0].MES_REF}/${this.state.salario[0].ANO_REF}` : ""}
        />

        <Row className={"mt-4"}>
          <Col tamanho={"md-6"}>
            <UltimasContribuicoes
              salario={this.state.salario}
              valorFuneral={this.state.valores.funeral}
              valorInvalidez={this.state.valores.invalidez}
            />
          </Col>

          <Col tamanho={"md-6"}>
            <Saldo ultimaContribuicao={this.state.ultimaContribuicao} plano={this.props.plano} />
          </Col>
        </Row>

        <Row>
          <Col>
            <CapitalSegurado capitalSegurado={this.state.CapitalSegurado} valorInvalidez={this.state.valores.funeral} />
          </Col>
          <Col>&nbsp;</Col>
        </Row>
      </>
    );
  };

  renderSemBeneficio = () => {
    return <Alerta tipo={TipoAlerta.danger} mensagem={"Nenhum dado disponível para este plano."} />;
  };

  render() {
    return (
      <MasterPage Funcionalidade={NumFuncionalidade.HOME_ATIVOS_E_AUTOPATROCINADOS} ref={this.page} {...this.props}>
        {this.state.ultimaContribuicao ? this.renderComBeneficio() : this.renderSemBeneficio()}
      </MasterPage>
    );
  }
}
